import { render, staticRenderFns } from "./Teeth.vue?vue&type=template&id=e59d6fba"
import script from "./Teeth.vue?vue&type=script&lang=js"
export * from "./Teeth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports